import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ReportHeaderSnippet } from '../models/report-definition';

@Component({
   selector: 'app-report-summary-header',
   standalone: true,
   imports: [CommonModule],
   templateUrl: './report-summary-header.component.html',
   styleUrls: ['./report-summary-header.component.scss']
})
export class ReportSummaryHeaderComponent {
   @Input() title = '';
   @Input() businessDateLabel = 'Business Date';
   @Input() businessDateText = '';
   @Input() snippets: ReportHeaderSnippet[] = [];

   @Input() actionLabel = '';
   @Input() actionDisabled = false;

   @Output() actionRequested = new EventEmitter<void>();

   onActionRequested(): void {
      this.actionRequested.emit();
   }

   getSnippetToneClass(snippet: ReportHeaderSnippet): string {
      return `tone-${snippet.tone ?? 'neutral'}`;
   }
}
